<template>
    <b-modal
        ref="product-category-select-modal"
        cancel-variant="outline-secondary"
        size="xl"
        cancel-title="Close"
        centered
        :title="title"
        hide-footer
        @hidden="hidden"
    >
        <ProductCategorySelect
            :selected-items="selected"
            :hide-hierarchy-column="hideHierarchyColumn"
            @change="change"
        />
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import ProductCategorySelect from "@core/components/product/ProductCategorySelect";

export default {
    components: {
        BModal,
        ProductCategorySelect
    },
    props: {
        selected: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            default() {
                return this.$t('Component(CategorySelectorModal):title')
            }
        },
        hideHierarchyColumn: {
            default: false
        }
    },
    methods: {
        show() {
            this.$refs['product-category-select-modal'].show();
        },
        hidden() {
            this.$emit('modalClosed');
        },
        change(e) {
            this.$emit('change', e)
        }
    }
}
</script>

<style scoped>

</style>
